import { render, staticRenderFns } from "./r-trader-offer-dropdown.vue?vue&type=template&id=2dda19c0"
import script from "./r-trader-offer-dropdown.vue?vue&type=script&lang=js"
export * from "./r-trader-offer-dropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2dda19c0')) {
      api.createRecord('2dda19c0', component.options)
    } else {
      api.reload('2dda19c0', component.options)
    }
    module.hot.accept("./r-trader-offer-dropdown.vue?vue&type=template&id=2dda19c0", function () {
      api.rerender('2dda19c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/trader/r-trader-offer-dropdown.vue"
export default component.exports